const messages = {
  es: {
    translations: {
      aiOperational: {
        blockedReply: "Sigo aquí para ayudarle con su atención.",
        blockedAudit: "Acción de IA no ejecutada por las reglas de atención",
        summaryMissingTime: "Ingrese los plazos para revisar la secuencia de cierre.",
        summaryNoInactivity: "Cierre por falta de respuesta desactivado.",
        summaryNoFollowUp: "Seguimiento desactivado.",
        summaryFollowUp: "Seguimiento después de {{minutes}} minuto(s) sin respuesta.",
        summaryCommunication: "Mensaje al cerrar: {{mode}}.",
        summaryResolution: "Cierre por conclusión: {{mode}}.",
        summaryNoTransfer: "Transferencias desactivadas.",
        summaryTransfer: "Transferencias permitidas a {{count}} destino(s).",
        summaryTitle: "Revise antes de guardar",
        followUpInstructionHelp: "Describa cómo retomar la conversación. Este es el único campo de seguimiento en el modo actual.",
        minutesHelp: "Ingrese un número entero mayor que cero.",
        inactivityMinutes: "Esperar antes del cierre (minutos)",
        followUpMinutes: "Esperar antes del seguimiento (minutos)",
        resolutionHelp: "Elija cuándo el agente puede reconocer la conclusión. Una falla técnica o una solicitud pendiente no indican atención concluida.",
        confirmationHelp_not_required: "El agente puede decidir transferir sin pedir confirmación, respetando los destinos y las reglas configuradas.",
        confirmationHelp_always: "Aunque el contacto solicite la transferencia directamente, el agente debe pedir confirmación.",
        confirmationHelp_direct_request_or_acceptance: "Si el contacto lo solicita directamente, el agente puede transferir. Si el agente lo sugiere, debe esperar la aceptación.",
        noDestinations: "No se encontraron destinos.",
        aiNotAllowed: "Este sector no permite agentes de IA.",
        agentNotReady: "El agente de destino aún no está activo y listo para recibir transferencias.",
        unavailableDestination: "Destino no disponible en la configuración actual.",
        selfDestination: "El agente no puede transferir a sí mismo.",
        savedUnavailable: "Destino guardado no disponible",
        missingDestinations: "Hay {{count}} destino(s) guardado(s) fuera de la lista actual. Fueron preservados; revise la configuración antes de guardar.",
        selectGroup: "Seleccionar este sector",
        clearEligible: "Desmarcar los disponibles",
        selectAll: "Seleccionar todos los disponibles",
        selectedCount: "Destinos seleccionados: {{count}}",
        searchDestinations: "Buscar sector o persona",
        followUpTitle: "Seguimiento y cierre",
        transferTitle: "Transferencias",
        unsupportedPolicy: "La configuración guardada usa un formato desconocido. Sus datos fueron preservados. Solicite una revisión antes de cambiar el modo.",
        legacyMode: "Este agente usa el modo anterior. Sus opciones de mensajes proactivos y cierre siguen disponibles abajo. Habilitar las nuevas reglas cambia el modo al guardar.",
        currentMode: "Estas opciones controlan transferencia, seguimiento y cierre. Los valores del modo anterior siguen guardados.",
        loading: "Cargando disponibilidad y destinos...",
        transferInstruction: "Instrucción breve sobre cuándo transferir",
        followUpPreview: "Respuesta enviada → espera {{followUp}} min → envía seguimiento → espera otros {{close}} min → cierra si no hay respuesta y la atención puede cerrarse.",
        directPreview: "Respuesta enviada → espera {{close}} min → cierra si no hay respuesta y la atención puede cerrarse.",
  "title": "Reglas de atención",
  "help": "Configure lo que puede hacer el agente. Defina permisos y plazos aquí; use las instrucciones para orientar la conversación.",
  "ready": "Reglas disponibles en este entorno.",
  "pending": "Estas reglas aún no están habilitadas en este entorno. Puede preparar la configuración; se usará después de la habilitación.",
  "catalogFailed": "No se pudieron cargar los destinos. Vuelva a abrir el formulario antes de configurar transferencias.",
  "enable": "Usar reglas de transferencia y cierre",
  "transfer": "Permitir transferencias",
  "destinationsHelp": "Elija sectores o personas para recibir transferencias. Una persona puede aparecer en varios sectores. Esta selección no cambia los sectores donde atiende este agente.",
  "defaultDestination": "Destino para solicitudes sin sector",
  "askDestination": "Preguntar el destino",
  "confirmation": "Cuándo pedir confirmación para transferir",
  "directOrAccept": "Al sugerir la transferencia",
  "always": "Pedir confirmación siempre",
  "notRequired": "Permitir transferencia sin confirmación",
  "continuity": "Al transferir a otro agente de IA, la solicitud y los documentos relacionados acompañan la atención.",
  "resolution": "Cuándo cerrar una atención concluida",
  "off": "Desactivado",
  "activeOnly": "Cuando el contacto responda al seguimiento",
  "clearResolution": "Cuando identifique que la atención concluyó",
  "followUp": "Enviar seguimiento cuando el contacto deje de responder",
  "inactivity": "Cerrar si el contacto sigue sin responder",
  "minutes": "Minutos — obligatorio y mayor que cero",
  "followUpAnchor": "En V2, la respuesta de la IA o el envío confirmado por API inicia el primer plazo. Después del seguimiento comienza el plazo de cierre. Si la IA elige silencio sin pendientes o el canal impide el seguimiento, continúa la inactividad sin otro seguimiento.",
  "directAnchor": "Sin seguimiento, el plazo de cierre empieza tras un envío confirmado. En V2, el silencio de la IA también inicia este plazo si no hay oferta ni trabajo pendiente del equipo. Fuera de la ventana de WhatsApp Oficial, el cierre es silencioso.",
  "cancelHelp": "Una nueva respuesta, intervención humana, transferencia o reapertura cancela el plazo anterior. Las fallas de envío no inician plazos. Cambiar estas reglas también cancela los plazos anteriores.",
  "followUpInstruction": "Instrucción breve para el seguimiento",
  "communication": "Comunicación al cerrar",
  "silent": "Sin mensaje adicional",
  "farewell": "Una despedida configurada",
  "farewellText": "Texto de despedida",
  "validation": "Valide en conversaciones de prueba separadas: solicitud directa, oferta aceptada y rechazada, respuesta ambigua, resolución clara y solicitud pendiente. Revise cola, responsable, estado e historial; el texto del agente no demuestra la ejecución."
},
      myProfile: {
        title: "Mi perfil", description: "Actualice sus datos personales y preferencias. Los permisos, colas y horarios son administrados por la organización.", changePhoto: "Cambiar foto", photoHelp: "PNG, JPG o WebP.", name: "Nombre", email: "Correo electrónico", password: "Nueva contraseña", passwordHelp: "La contraseña actual no se muestra. Déjelo vacío para conservarla o escriba una nueva contraseña.", language: "Idioma", ticketOrder: "Orden de conversaciones", oldestFirst: "Más antiguas primero", newestFirst: "Más recientes primero", save: "Guardar cambios", saving: "Guardando...", success: "Perfil actualizado correctamente."
      },
      organization: {
        title: "Organización", description: "Identidad, datos institucionales y preferencias generales del tenant.", guidance: "Esta información pertenece a su empresa y está aislada de los demás tenants. Solo los administradores pueden modificarla.", logo: "Logotipo claro", logoDark: "Logotipo oscuro", logoHelp: "PNG, JPG o WebP; máximo 2 MB.", name: "Nombre de la empresa", businessName: "Razón social", document: "Identificación fiscal o documento", phone: "Teléfono", email: "Correo institucional", website: "Sitio web", address: "Dirección", timezone: "Zona horaria", defaultLanguage: "Idioma predeterminado", primaryColor: "Color principal", tenantId: "Código del tenant", save: "Guardar organización", saving: "Guardando...", success: "Datos de la organización actualizados."
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          companyName: "Empresa",
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          language: "Idioma",
          languageOptions: {
            pt: "Portugués (Brasil)",
            en: "English",
            es: "Español"
          }
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atenciones hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        },
        indicators: {
          title: "Indicadores",
          filters: {
            period: "Periodo",
            start: "Inicio",
            end: "Fin",
            queue: "Cola",
            connection: "Conexion",
            allQueues: "Todas mis colas",
            allConnections: "Todas las conexiones",
            nowNote: "Ahora muestra la situacion actual. Use Cola y Conexion para recortar este retrato.",
            periodNote: "Periodo, Cola y Conexion filtran los indicadores de esta pestana.",
          },
          periods: {
            today: "Hoy",
            yesterday: "Ayer",
            thisWeek: "Esta semana",
            lastWeek: "Semana pasada",
            thisMonth: "Este mes",
            lastMonth: "Mes pasado",
            custom: "Otro periodo",
          },
          tabs: {
            now: "Ahora",
            period: "Periodo",
            agents: "Agentes",
            queues: "Colas",
            connections: "Conexiones",
            lists: "Listas",
          },
          periodMetrics: {
            started: "Entradas",
            reopened: "Reabiertos",
            closed: "Cerrados",
            reopenRate: "Tasa de reapertura",
            firstResponse: "Primera respuesta media",
            resolution: "Resolucion media",
            inbound: "Mensajes recibidos",
            outbound: "Mensajes enviados",
            closedByHour: "Cerrados por hora",
          },
          global: {
            health: "Temperatura de la Operacion",
            waitingForService: "Esperando Atencion",
            inService: "En Atencion",
            unanswered: "Atencion sin Respuesta",
            averageWait: "Tiempo Medio de Espera",
            longestWait: "Mayor Espera",
            busiestAgent: "Con mas Atenciones en Atencion",
            busiestArea: "Con mas Atenciones en Espera",
            healthDescription: "Salud general de la atencion ahora, sin depender de los filtros de abajo.",
            scale: {
              excellent: "Excelente",
              good: "Buena",
              warning: "Atencion",
              critical: "Critica",
              emergency: "Emergencia",
            },
          },
          help: {
            tooltip: "Ayuda del indicador",
            compositionTitle: "Que entra en el calculo",
            improveTitle: "Como mejorar",
            close: "Cerrar",
            backlog: {
              title: "Backlog activo",
              description: "Cantidad de tickets abiertos + pendientes dentro del alcance de las colas a las que puede acceder.",
              insight: "Reduzca el backlog con triaje rapido, distribucion por cola y automatizaciones para preguntas recurrentes.",
            },
            waiting: {
              title: "% en espera",
              description: "Porcentaje de pendientes sobre abiertos + pendientes. Cuanto mayor, mayor es el cuello de botella del triaje.",
              insight: "Defina alertas cuando supere el limite y tome atenciones para evitar el envejecimiento de la cola.",
            },
            unread: {
              title: "No leidos totales",
              description: "Conversaciones con mensajes aun no leidos en su alcance.",
              insight: "Priorice no leidos antiguos y use alertas por tiempo sin lectura.",
            },
            ratio: {
              title: "Relacion atencion vs cola",
              description: "Compara tickets abiertos con pendientes. Mayor que 1 indica que el equipo esta tomando la cola.",
              insight: "Mantengala por encima de 1 en horas pico con ajuste de escala y enrutamiento.",
            },
            flow: {
              title: "Flujo por hora",
              description: "Distribucion por hora basada en el volumen del periodo dentro del filtro aplicado.",
              insight: "Use los horarios pico para reforzar el equipo y automatizaciones preventivas.",
            },
            age: {
              title: "Edad de los tickets",
              description: "Rangos por tiempo sin evolucion para abiertos y pendientes.",
              insight: "Tickets de mas de 60 minutos deben entrar en una cola de prioridad.",
            },
            queue: {
              title: "Tickets por cola",
              description: "Principales colas en el periodo filtrado.",
              insight: "Rebalancee el equipo cuando una cola concentre mucho volumen.",
            },
            agentAvg: {
              title: "Tiempo medio por agente",
              description: "Promedio entre apertura y ultima actualizacion de los tickets cerrados por agente en el periodo filtrado.",
              insight: "Compare con el volumen atendido para identificar cuellos de botella y apoyar al equipo con mayor cola media.",
            },
            channel: {
              title: "Tickets por conexion",
              description: "Distribucion por conexion en el periodo filtrado.",
              insight: "Dirija automatizaciones a conexiones con mayor entrada.",
            },
            group: {
              title: "Grupos vs Individuales",
              description: "Compara tickets de grupos con conversaciones individuales.",
              insight: "Si los grupos crecen, aplique reglas y responsables fijos para reducir ruido.",
            },
          },
          sections: {
            flow: "Flujo por hora",
            closed: "Cerrados: {{count}}",
            ageRanges: "Rangos de edad",
            ticketsByQueue: "Tickets por cola (Top 10)",
            ticketsByConnection: "Tickets por conexion",
            groupsVsIndividuals: "Grupos vs Individuales",
            agentAverage: "Tiempo medio de atencion por agente (Top 10)",
            operationalInsights: "Insights operativos",
            currentSample: "Muestra en el filtro actual: {{count}} tickets",
            agents: "Desempeno por agente",
            queues: "Desempeno por cola",
            connections: "Desempeno por conexion",
          },
          empty: {
            movement: "Sin movimiento en el periodo. Amplie el periodo o seleccione otra conexion.",
            age: "Sin tickets activos en el periodo para calcular rangos de edad.",
            queue: "Sin volumen por cola en el periodo seleccionado.",
            connection: "Sin volumen por conexion en el periodo seleccionado.",
            group: "Sin tickets suficientes para comparar grupos e individuales.",
            agentAverage: "Sin tickets cerrados con agente en el periodo seleccionado.",
            noData: "Sin datos para el filtro seleccionado.",
          },
          rank: {
            active: "activos",
            closed: "cerrados",
            sent: "enviados",
            waiting: "esperando",
            inService: "en atencion",
            started: "entradas",
            inbound: "recibidos",
          },
          table: {
            agent: "Agente",
            agentType: "Tipo de agente",
            queue: "Cola",
            connection: "Conexion",
            channel: "Canal",
            active: "Abiertos",
            waiting: "Esperando",
            inService: "En atencion",
            started: "Entradas",
            closed: "Cerrados",
            closedPercentage: "Porcentaje de cerrados",
            sent: "Mensajes enviados",
            inbound: "Recibidos",
            avgWait: "Espera media",
            avgResolution: "Tiempo de resolucion",
          },
          attendantType: {
            human: "Humano",
            aiAgent: "Agente de IA",
            unassigned: "Sin agente",
          },
          actionLists: {
            waitingLongest: "Esperando hace mas tiempo",
            unanswered: "Sin respuesta del agente",
            slaRisk: "Riesgo de SLA",
            reopened: "Reabiertos en el periodo",
          },
          fallback: {
            connection: "Conexion {{id}}",
            noQueue: "Sin cola",
            noConnection: "Sin conexion",
            noAgent: "Sin agente",
            noDefinedQueue: "Sin cola definida",
            groups: "Grupos",
            individuals: "Individuales",
          },
          chart: {
            entries: "Entradas",
          },
          insights: {
            noBacklog: "Sin backlog activo en el alcance actual. Aproveche para revisar macros y reglas de triaje para los proximos picos.",
            highWaiting: "Cola bajo presion: {{pendingCount}} pendientes ({{waitingPercent}}%). Reasigne agentes a colas con mayor volumen inmediatamente.",
            mediumWaiting: "Atencion en espera: {{waitingPercent}}% de los tickets estan pendientes. Defina un esfuerzo corto para reducir pendientes por debajo de 25%.",
            oldestPending: "Existe un ticket pendiente hace {{minutes}} min. Priorice los mas antiguos para proteger el SLA.",
            unread: "Hay {{count}} conversaciones no leidas. Ordene por mas antiguas y limpie en lotes de 10.",
            topQueue: "La cola {{name}} concentra {{share}}% del volumen. Evalue redistribucion del equipo o automatizacion dedicada.",
            topConnection: "La conexion {{name}} representa {{share}}% de la demanda. Vale revisar capacidad y plantillas de esa conexion.",
            stable: "Operacion estable en el filtro actual. Mantenga monitoreo por hora y ajuste fino por cola cuando haya pico.",
          },
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          restarting: "Reiniciando la conexión. Espere unos instantes.",
          paused: "Conexión pausada. Use Reiniciar conexión para volver sin leer el QR Code.",
          disconnected: "Conexión desconectada. Para volver, genere y lea un nuevo QR Code.",
          openTicketsHistorySynced:
            "Historial sincronizado en {{tickets}} atenciones abiertas. {{messages}} mensajes nuevos importados. Fallas: {{failures}}.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          restart: "Reiniciar conexión",
          connecting: "Conectando",
          sessionActions: "Acciones de la sesión",
        },
        sessionMenu: {
          viewQr: "Ver QR Code actual",
          viewQrHelp: "Muestra el QR Code cuando la conexión espera lectura.",
          restart: "Reiniciar sin nuevo QR",
          restartHelp: "Cierra y abre la sesión local manteniendo la autenticación del celular.",
          pause: "Pausar conexión",
          pauseHelp: "Detiene la sesión local sin cerrar WhatsApp en el celular.",
          syncOpenTicketsHistory: "Sincronizar atenciones abiertas",
          syncOpenTicketsHistoryHelp:
            "Busca mensajes recientes de WhatsApp para tickets abiertos de esta conexión.",
          newQr: "Solicitar nuevo QR Code",
          newQrHelp: "Limpia la sesión local y genera un nuevo QR Code para leer.",
          disconnect: "Desconectar del celular",
          disconnectHelp: "Cierra WhatsApp Web. Para volver, será necesario leer un nuevo QR Code.",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono esté conectado a Internet e intente reiniciar la conexión. Solicite un nuevo código QR solo si la sesión no vuelve.",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono esté conectado a Internet y que WhatsApp esté abierto. Use Reiniciar conexión antes de solicitar un nuevo código QR.",
          },
        },
        table: {
          id: "ID",
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      connectionSetup: {
        back: "Volver",
        cancel: "Cancelar",
        close: "Cerrar",
        save: "Guardar",
        saving: "Guardando...",
        retry: "Volver a probar",
        connectWithMeta: "Conectar con Meta",
        connecting: "Conectando...",
        waitingMeta: "Esperando a Meta...",
        configureManually: "Configurar manualmente",
        officialApi: "API Oficial",
        qrCode: "QR Code",
        noDefaultQueue: "Sin cola predeterminada",
        selectQueue: "Seleccione una cola",
        defaultConnection: "Marcar como predeterminada",
        makeDefaultConnection: "Hacer conexion predeterminada",
        connectionName: "Nombre de la conexion",
        queueForNewContacts: "Cola para nuevos contactos",
        outboundQueues: "Colas autorizadas para conversaciones salientes",
        outboundQueuesHelp: "Seleccione qué colas pueden usar esta conexión al iniciar manualmente una conversación.",
        userForNewContacts: "Usuario para nuevos contactos",
        userForNewContactsHelp: "Opcional. Seleccione un humano o agente de IA para asumir automaticamente las nuevas conversaciones de esta conexion.",
        selectUser: "Seleccione un usuario",
        webhookUrl: "Webhook URL",
        webchat: {
          customizationSaveHelp: "Ajuste la apariencia y haga clic en Guardar personalizacion para aplicarla a esta conexion. El snippet publicado sigue igual y no caduca; solo debe reemplazarlo si se vuelve a crear la conexion o se rota la clave publica por seguridad.",
          saveCustomization: "Guardar personalizacion",
          customizationSaved: "Personalizacion del Webchat guardada correctamente.",
          prechatTitle: "Campos antes del chat",
          prechatHelp: "Elija que datos debe informar el visitante antes de conversar. Si todas las opciones quedan apagadas, el chat abre directo en la conversacion.",
          askName: "Pedir nombre",
          askEmail: "Pedir e-mail",
          askWhatsapp: "Pedir WhatsApp",
          showFrame: "Mostrar marco en Embed Line",
          showFrameHelp: "Desactívelo para integrar el chat en el diseño del sitio. Antes del primer mensaje solo aparece el compositor compacto; después del envío, la conversación se expande automáticamente.",
        },
        facebook: {
          titleAdd: "Nueva conexion de Facebook Messenger",
          titleEdit: "Editar Facebook Messenger",
          autoDescription: "Inicie sesion con la cuenta Meta que administra la Pagina, autorice la app Flowch y elija que Pagina recibira mensajes en Flowch Talk. El token de la Pagina, webhook y suscripcion son tratados automaticamente por el backend.",
          manualDescription: "Use esto solo cuando soporte o implementacion tecnica necesite informar Page ID, Page Access Token y Verify Token directamente.",
          manualIntro: "Use esta conexion para recibir mensajes de la Pagina de Facebook por Messenger. El contacto debe iniciar la conversacion desde la Pagina; despues Flowch Talk puede responder dentro de la ventana permitida por Meta.",
          pageIdHelp: "ID de la Pagina de Facebook que recibira los mensajes.",
          pageAccessTokenEdit: "Page Access Token (opcional para mantener el actual)",
          pageAccessTokenHelp: "Token de la Pagina con permiso para enviar mensajes por Messenger.",
          verifyTokenHelp: "Cree una palabra clave segura y use exactamente el mismo valor en la configuracion del webhook de Meta.",
          queueHelp: "Los mensajes recibidos por la Pagina entran en esta cola.",
          webhookTitle: "Configurar webhook en Meta",
          webhookInstructions: "1. Guarde esta conexion. 2. En la app de Meta, configure el webhook de Messenger usando la URL de abajo. 3. Informe el mismo Verify Token registrado aqui. 4. Suscriba los eventos de mensajes de la Pagina y envie un mensaje de prueba por Messenger.",
          autoIntro: "Informe una identificacion interna y la cola predeterminada. Luego haga clic en Conectar con Meta. El cliente debe iniciar sesion con una cuenta que administra la Pagina, aceptar los permisos solicitados y seleccionar la Pagina que sera conectada. Al finalizar, Flowch Talk guarda las credenciales con seguridad, suscribe el webhook y ejecuta el diagnostico automaticamente.",
          nameAutoHelp: "Si lo deja en blanco, Flowch crea un nombre automaticamente.",
          choosePageTitle: "Elija la Pagina de Facebook",
          choosePageHelp: "La conexion sera creada con la Pagina seleccionada. Despues, seguira disponible para editar nombre, cola, predeterminada y credenciales en modo manual cuando soporte lo necesite.",
          pageLabel: "Pagina",
          complete: "Completar conexion",
          subscribeWebhook: "Suscribir webhook de la Pagina",
          validationRequired: "Informe nombre, Page ID, Verify Token y Token de la Pagina.",
          updated: "Conexion de Facebook Messenger actualizada correctamente.",
          created: "Conexion de Facebook Messenger creada correctamente.",
          metaStartFailed: "No fue posible iniciar el flujo de Meta.",
          popupBlocked: "Su navegador bloqueo el popup de Meta. Permita popups e intente nuevamente.",
          finishLogin: "Finalice el login de Meta en la ventana abierta para listar sus Paginas.",
          selectPage: "Seleccione una Pagina de Facebook para continuar.",
          pageNotFound: "Pagina seleccionada no encontrada.",
          diagnosisPending: "Conexion creada, pero el diagnostico encontro pendientes.",
          loginCompleted: "Login de Meta concluido. Seleccione la Pagina para conectar.",
          webhookSubscribed: "Suscripcion del webhook solicitada correctamente.",
        },
        whatsappOfficial: {
          titleAdd: "Nueva conexion de WhatsApp Oficial (API)",
          titleEdit: "Editar WhatsApp Oficial (API)",
          autoDescription: "Inicie sesion con la cuenta Meta que administra la empresa, seleccione el WABA y el numero de WhatsApp. Flowch Talk guarda las credenciales, configura el webhook y ejecuta el diagnostico automaticamente.",
          manualDescription: "Use esto cuando soporte o implementacion tecnica necesite informar campos de API Oficial manualmente o conectar por QR Code.",
          officialApiDescription: "Use los datos de su cuenta Meta, como WABA ID, Phone Number ID, token y verify token.",
          qrCodeDescription: "Conecte manualmente una cuenta mediante emparejamiento de WhatsApp Web cuando la API Oficial no sea la mejor opcion.",
          manualIntro: "Informe WABA ID, Phone Number ID, Access Token y Verify Token de WhatsApp Business Platform. Luego guarde y pruebe la conexion para validar token, numero, WABA y webhook.",
          metaIntro: "Haga clic en Conectar con Meta, autorice los permisos solicitados y elija la empresa/numero de WhatsApp. Al finalizar, Flowch Talk obtiene WABA ID, Phone Number ID y token, suscribe el webhook de Meta y muestra el diagnostico final.",
          cloudApiModeTitle: "Nuevo número / API",
          cloudApiModeDescription: "Conecta un número nuevo o uno ya preparado exclusivamente para la API Oficial de Meta.",
          coexistenceModeTitle: "Seguir usando WhatsApp Business",
          coexistenceModeDescription: "Mantén el mismo número en la aplicación WhatsApp Business y atiende también desde Flowch Talk.",
          coexistenceIntro: "Haz clic en Conectar con Meta y elige el número que ya está activo en la aplicación WhatsApp Business. Flowch confirma la coexistencia, importa el historial autorizado y refleja los mensajes enviados desde el teléfono sin activar la IA.",
          coexistenceEligibilityHelp: "Requisitos de Meta: aplicación WhatsApp Business actualizada, número elegible y coexistencia habilitada para la app Flowch. Esta opción no desconecta el teléfono automáticamente.",
          coexistenceConfigurationPending: "No disponible en este entorno hasta completar la configuración de la aplicación en Meta.",
          coexistenceUnavailable: "La coexistencia aún no está configurada en este entorno. Usa Nuevo número / API o solicita su activación al soporte.",
          coexistenceBadge: "Coexistencia",
          metaApplicationLabel: "Aplicación Meta",
          metaApplicationHelp: "Usa la aplicación Flowch configurada en este entorno o selecciona una aplicación propia de la empresa. Las firmas del webhook y Embedded Signup usarán solo las credenciales elegidas aquí.",
          metaApplicationFlowchDefault: "Aplicación Flowch predeterminada del entorno",
          metaApplicationOwnerFlowch: "Flowch",
          metaApplicationOwnerCompany: "Aplicación propia",
          metaApplicationAdd: "Registrar aplicación propia",
          metaApplicationEdit: "Editar aplicación",
          metaApplicationAddTitle: "Registrar aplicación Meta de la empresa",
          metaApplicationEditTitle: "Editar aplicación Meta de la empresa",
          metaApplicationInstructions: "En Meta for Developers, copie App ID y App Secret. Defina un Verify Token para el webhook. Los Config ID se requieren solo para Embedded Signup/coexistencia. Después de guardar, use la URL mostrada y suscríbase a messages. Los secretos se cifran y no se devuelven.",
          metaApplicationName: "Nombre interno de la aplicación",
          metaApplicationSecretHelp: "El App Secret se almacena cifrado y nunca volverá a mostrarse.",
          metaApplicationVerifyTokenEditHelp: "Déjelo vacío para conservar el Verify Token actual. Para sustituirlo, indique al menos 16 caracteres y actualice el mismo valor en el webhook de Meta; la verificación puede fallar hasta actualizar ambos lados.",
          metaApplicationVerifyTokenRequired: "Defina un Verify Token de al menos 16 caracteres para una app nueva. Al editar, déjelo vacío para conservar el valor actual.",
          metaApplicationConfigHelp: "Necesario solo para Conectar con Meta (Embedded Signup). La configuración manual no requiere Config ID.",
          metaApplicationWebhookChecklist: "En Meta, use esta URL de callback y el Verify Token definido para la app; suscríbase a messages. Después revise el diagnóstico. Guardar no demuestra envío ni recepción de mensajes.",
          setupQueueMissing: "No hay colas disponibles. Cierre este formulario, cree una cola en Colas y vuelva a Conexiones. Se requiere una cola de destino.",
          manualVerifyTokenHelp: "Indique el Verify Token definido para la app seleccionada. Para la app predeterminada del entorno, use su token configurado. No use el Access Token en este campo.",
          manualSaveEffects: "Guardar puede configurar el webhook y suscribir la app a la cuenta de WhatsApp con las credenciales elegidas. Guardar y probar crea la conexión antes de consultar Meta. Ninguna acción envía un mensaje de prueba.",
          testConnection: "Probar conexión",
          saveAndTestConnection: "Guardar y probar conexión",
          metaApplicationVerifyTokenHelp: "Defina un Verify Token de al menos 16 caracteres y guárdelo de forma segura para el campo Verificar token de Meta. No es el Access Token. El valor guardado no se mostrará de nuevo.",
          metaApplicationSave: "Guardar aplicación",
          metaApplicationDelete: "Eliminar aplicación",
          metaApplicationDeleteConfirm: "¿Eliminar esta aplicación Meta? Solo se permite si ninguna conexión está vinculada.",
          metaApplicationWebhookHelp: "URL para registrar en el webhook de Meta",
          metaApplicationRequired: "Informe nombre, App ID y App Secret.",
          metaApplicationSaved: "Aplicación Meta guardada de forma segura.",
          metaApplicationRemoved: "Aplicación Meta eliminada.",
          selectQueueRequired: "Selecciona la cola para nuevos contactos.",
          secretKeepCurrent: "Déjalo en blanco para conservar la credencial almacenada de forma segura.",
          popupHelp: "Si el popup es bloqueado, permita popups para este dominio e intente nuevamente. La conexion creada por Meta sigue editable manualmente para ajustes futuros.",
          manualRequired: "Complete todos los campos de configuracion manual.",
          saved: "Conexion oficial guardada correctamente.",
          tested: "Conexion probada correctamente.",
          templatesSynced: "Plantillas sincronizadas correctamente.",
          friendlyNamesSaved: "Nombres amigables guardados.",
          templateFieldsRequired: "Informe el nombre tecnico y el texto principal de la plantilla.",
          templateSubmitted: "Plantilla enviada a Meta para aprobacion.",
          metaCancelled: "El flujo de Meta fue cancelado antes de concluir.",
          metaAuthFailed: "Fallo la autenticacion con Meta.",
          metaReturnFailed: "No fue posible concluir el retorno de Meta.",
          metaStartFailed: "No fue posible iniciar el flujo de Meta.",
          finishMetaSetup: "Finalice el login de Meta en la ventana abierta para completar la conexion automaticamente.",
          created: "Conexion oficial creada correctamente.",
          diagnosisPending: "Conexion creada, pero el diagnostico encontro pendientes.",
          diagnosisConnectionName: "WhatsApp Oficial",
          templates: {
            createTitle: "Crear plantilla en Meta",
            createHelp: "Usa variables con nombres claros e informa un ejemplo para cada una. Meta revisará la plantilla y solo podrá usarse después de su aprobación.",
            technicalName: "Nombre técnico (Meta)",
            technicalNameHelp: "Usa solo letras minúsculas, números y guiones bajos.",
            friendlyName: "Nombre amigable (interno)",
            category: "Categoría",
            language: "Idioma",
            parameterFormat: "Formato de las variables",
            namedFormat: "Por nombre — recomendado",
            positionalFormat: "Por posición — avanzado",
            namedHelp: "Más fácil de configurar y mantener. Usa nombres como nome y data.",
            positionalHelp: "Compatibilidad con plantillas antiguas. Usa posiciones numeradas en secuencia.",
            insertVariable: "Insertar una variable común",
            body: "Texto principal (BODY)",
            bodyNamedHelp: "Usa los botones de arriba o escribe variables con nombres en minúsculas.",
            bodyPositionalHelp: "Usa variables numeradas en secuencia, empezando por la posición 1.",
            exampleFor: "Ejemplo para {{variable}}",
            createAction: "Enviar para revisión de Meta",
            mixedVariablesError: "No mezcles variables por nombre y por posición en la misma plantilla.",
            namedFormatError: "En el formato recomendado, usa variables con nombres en lugar de números.",
            positionalFormatError: "En el formato por posición, usa solo números consecutivos.",
            examplesRequired: "Informa un ejemplo para cada variable antes de enviar a Meta.",
          },
        },
        diagnosis: {
          title: "Diagnostico Meta - {{name}}",
          retry: "Volver a probar",
          close: "Cerrar",
          labels: {
            pageId: "Page ID",
            verifyToken: "Verify Token",
            webhookUrl: "URL del Webhook",
            secrets: "Credenciales guardadas",
            pageAccessToken: "Page Access Token",
            pageTokenMatch: "Token x Pagina",
            pageWebhookSubscription: "Suscripciones de la Pagina",
            recentInbound: "Recepcion de mensajes",
            diagnose: "Diagnostico general",
            defaultCheck: "Verificacion",
            webhookMeta: "Webhook Meta",
          },
          webhookUnavailable: "Diagnostico de webhook no disponible.",
          expectedVsMeta: "Esperado: {{expected}} | Meta: {{meta}}",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          defaultUser: "Usuario para nuevos contactos",
          farewellMessage: "Mensaje de despedida",
          outboundQueues: "Colas autorizadas para conversaciones salientes",
          outboundQueuesHelp: "Estas colas podrán seleccionar esta conexión al crear una conversación manualmente.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          saving: "Guardando...",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todas las atenciones relacionadas se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          numberHelp: "Brasil (+55) se aplica automáticamente. Puede pegar el número con espacios, paréntesis o guiones.",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        validation: {
          nameTooShort: "Ingrese al menos 2 caracteres.",
          nameTooLong: "El nombre debe tener como máximo 50 caracteres.",
          nameRequired: "Ingrese el nombre.",
          numberRequired: "Ingrese el número de WhatsApp.",
          numberInvalid: "Ingrese un teléfono válido con código de área. +55 se agregará automáticamente.",
          emailInvalid: "Ingrese un correo electrónico válido.",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          saving: "Guardando...",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          saving: "Guardando...",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        tabs: {
          basicData: "Datos básicos",
          integrations: "Integraciones",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
          startAttendanceMessage: "Mensaje al Iniciar la Atención",
          finishAttendanceMessage: "Mensaje al Finalizar la Atención",
          allowManualAttendance: "Permitir atención manual en esta cola",
          allowAiAgents: "Permitir agentes de IA en esta cola",
          allowAiAgentsHelp: "Cuando está desactivado, ningún usuario del tipo Agente de IA podrá asumir atenciones de esta cola.",
          aiHandoffQueue: "Cola para transferencia humana",
          aiHandoffQueueNone: "Sin cola predeterminada de transferencia",
          aiHandoffQueueHelp: "Cuando el agente de IA necesite pasar la conversación a una persona sin indicar usuario o sector, la atención se moverá a esta cola.",
        },
        integrations: {
          empty: "No hay integraciones agregadas.",
          integrationLabel: "Integración {{number}}",
          buttons: {
            add: "Agregar integración",
          },
          form: {
            type: "Tipo de integración",
            name: "Nombre de la integración",
            webhookUrl: "URL del webhook",
            triggerEvents: "Eventos disparadores",
            contact: "Contacto",
            specificContacts: "Contactos específicos",
            searchContactPlaceholder: "Escriba para buscar contactos",
            token: "Token (opcional)",
            status: "Estado",
          },
          types: {
            webhook: "Webhook",
            flowch: "Flowch",
          },
          flowch: {
            form: {
              endpointUrl: "URL de integración Flowch",
              docUrl: "Documento cargado",
              fieldMappings: "Mapeo de campos",
              mappingLabel: "Campo {{number}}",
              fieldName: "Nombre del campo",
              fieldLabel: "Texto de ayuda",
              valueMode: "Tipo de valor",
              source: "Origen en Talk",
              fixedValue: "Valor fijo",
            },
            buttons: {
              loadDoc: "Leer proceso",
              addField: "Agregar campo",
            },
            messages: {
              endpointRequired: "Complete la URL de integración para leer el proceso.",
              docLoaded: "Proceso leído correctamente. Campos listos para mapear.",
            },
            boolean: {
              yes: "Sí",
              no: "No",
            },
            valueMode: {
              talk: "Origen en Talk",
              fixed: "Valor fijo",
            },
            sources: {
              ticketId: "ID de la atención",
              messageId: "ID del mensaje",
              contactId: "ID del contacto",
              contactNumber: "Número del contacto",
              contactLid: "LID del contacto",
              contactIsGroup: "El contacto es grupo",
              messageContactId: "ID del autor del mensaje",
              messageContactName: "Nombre del autor del mensaje",
              messageContactNumber: "Numero del autor del mensaje",
              participantContactId: "ID del participante del grupo",
              participantName: "Nombre del participante del grupo",
              participantNumber: "Numero del participante del grupo",
              participantLid: "LID del participante del grupo",
              groupContactId: "ID del grupo",
              groupName: "Nombre del grupo",
              groupNumber: "Numero del grupo",
              messageBody: "Cuerpo del mensaje",
              fromMe: "Enviado por el agente",
              mediaType: "Tipo de medio",
              ticketStatus: "Estado de la atención",
              userId: "ID del usuario",
              whatsappId: "ID de la conexión",
              whatsappName: "Nombre de la conexión",
              connectionId: "ID de la conexión genérica",
              connectionName: "Nombre de la conexión genérica",
              channel: "Canal",
              provider: "Proveedor",
              event: "Evento de la integración",
              queueId: "ID de la cola",
              timestamp: "Fecha/hora de envío",
              fixed: "Valor fijo",
            },
          },
          status: {
            active: "Activo",
            inactive: "Inactivo",
          },
          contactScope: {
            all: "Todos los contactos",
            specific: "Contacto específico",
          },
          events: {
            messageReceived: "Mensaje recibido",
            messageSent: "Mensaje enviado",
            conversationStarted: "Conversación iniciada",
            conversationFinished: "Conversación finalizada",
          },
          test: {
            button: "Probar integración",
            resultTitle: "Resultado de la prueba",
            requestData: "Datos enviados",
            responseData: "Datos de retorno",
            messages: {
              success: "Prueba ejecutada con éxito.",
            },
          },
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          saving: "Guardando...",
          cancel: "Cancelar",
        },
      },
      userModal: {
        configuration: {
  "legacyTitle": "Opciones del modo anterior",
  "legacyHelp": "Usadas por agentes sin las nuevas reglas de atención. Sus valores siguen guardados al cambiar el modo.",
  "advancedTitle": "Configuración avanzada de IA",
  "advancedHelp": "Proveedor, modelo y límites. Cambie solo si comprende el efecto sobre el comportamiento y el consumo.",
  "knowledgeTitle": "Conocimiento y capacidades",
  "knowledgeHelp": "Organice información sobre servicios, profesionales, precios y especialidades. Las capacidades de integración también permanecen aquí; los permisos tienen sus propias opciones.",
  "permissionsTitle": "Permisos adicionales",
  "permissionsHelp": "Defina si el agente puede consultar el contexto, registrar notas y actualizar el contacto. Las transferencias del modo actual se configuran en Transferencias.",
  "saved": "Configuración guardada.",
  "synced": "Configuración guardada y sincronizada con Agents.",
  "syncPending": "Configuración guardada, pero no se confirmó la sincronización con Agents. Revise el estado antes de usar el agente.",
  "draftSaved": "Borrador guardado. El agente no se publicó.",
  "statusTitle": "Estado del agente",
  "statusReady": "Activo y listo",
  "statusDraft": "Borrador",
  "statusPending": "Necesita revisión",
  "statusHelp": "Este es el estado de la última configuración guardada. Los cambios en esta pantalla solo se aplican al guardar."
},
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        creationChoice: {
          title: "¿A quién quieres agregar?",
          help: "Elige una opción para ver solo las configuraciones necesarias.",
          humanTitle: "Persona",
          humanDescription: "Crea acceso para agentes, gestores o administradores del equipo.",
          aiTitle: "Agente de IA",
          aiDescription: "Sigue un flujo simple para elegir el sector, las capacidades y el comportamiento del agente.",
          humanSelected: "Nuevo usuario del equipo",
          humanSelectedHelp: "Completa los datos de acceso y atención.",
          aiSelected: "Nuevo agente de IA",
          aiSelectedHelp: "El asistente guiado aparece justo debajo de los datos de identificación.",
          changeType: "Cambiar tipo",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          userType: "Tipo de usuario",
          userTypeOptions: {
            human: "Humano",
            aiAgent: "Agente de IA",
          },
          language: "Idioma",
          profilePic: "Foto del usuario",
          ticketOrder: "Orden de atenciones",
          ticketOrderOptions: {
            oldestFirst: "Más antiguos primero",
            newestFirst: "Más nuevos primero",
          },
          whatsapp: "Conexión estándar",
        },
        sections: {
          userData: "Datos del usuario",
          userDataHelp: "Defina identificación, tipo de usuario y preferencias generales.",
          attendance: "Atención",
          attendanceHelp: "Configure las colas y la conexión estándar utilizadas por este usuario.",
        },
        humanWizard: {
          steps: { access: "Acceso", service: "Permisos", review: "Revisión" },
          accessTitle: "¿Cómo accederá esta persona a Talk?",
          accessHelp: "Introduce solo los datos necesarios para crear el acceso. Los demás ajustes se pueden cambiar después.",
          nameHelp: "Usa el nombre con el que el equipo reconoce a esta persona.",
          emailHelp: "Este será el correo utilizado para entrar en Talk.",
          passwordHelp: "Crea una contraseña inicial de al menos 5 caracteres y compártela por un canal seguro.",
          togglePassword: "Mostrar u ocultar contraseña",
          serviceTitle: "¿A qué podrá acceder esta persona?",
          serviceHelp: "Elige el nivel de permiso y dirige las conversaciones. Las colas y la conexión se pueden cambiar después.",
          roles: {
            agent: { title: "Agente", help: "Atiende conversaciones y utiliza los recursos habilitados por un administrador." },
            admin: { title: "Administrador", help: "Configura la empresa y gestiona usuarios, conexiones y todas las conversaciones." },
          },
          queuesTitle: "Colas de atención",
          queuesHelp: "Selecciona los temas o equipos que esta persona puede atender. Puedes continuar sin elegir una cola.",
          queuesLabel: "Seleccionar colas",
          noDefaultConnection: "Sin conexión predeterminada",
          reviewTitle: "Revisa antes de crear el acceso",
          reviewHelp: "Comprueba los datos. La contraseña no se muestra por seguridad.",
          review: {
            person: "Persona", access: "Correo de acceso", role: "Permiso", service: "Atención",
            queueCount: "{{count}} cola(s) seleccionada(s)", noQueues: "Todas o ninguna cola específica",
          },
          preferencesTitle: "Preferencias opcionales",
          preferencesHelp: "El idioma de la interfaz y el orden de las conversaciones ya tienen valores recomendados.",
          afterCreateHelp: "La foto, el horario de acceso y otros detalles se pueden configurar después al editar el usuario.",
          create: "Crear usuario",
        },
        aiAgent: {
          title: "Perfil del agente de IA",
          help: "Configure el comportamiento principal de este usuario agente. La sincronizacion con Flowch Agents ocurre en el backend.",
          description: "Descripcion",
          instructions: "Instrucciones del agente",
          llmProvider: "Proveedor LLM",
          llmModel: "Modelo LLM",
          temperature: "Temperatura",
          maxTokens: "Limite maximo de tokens",
          mediaTitle: "Archivos recibidos",
          mediaHelp: "Define que tipos de archivo este agente puede enviar a Flowch Agents. Talk no guarda transcripciones; solo reenvia el archivo cuando esta permitido.",
          allowAudioMessages: "Permitir audios",
          allowImageMessages: "Permitir imagenes",
          allowDocumentMessages: "Permitir documentos",
          maxMediaFileSizeMb: "Tamano maximo por archivo (MB)",
          responseDelaySeconds: "Esperar mensajes por segundos",
          proactiveDelayMinutes: "Mensaje activo despues de minutos sin respuesta",
          maxProactiveMessages: "Maximo de mensajes activos antes de cerrar",
          proactivePrompt: "Prompt del mensaje activo",
          unavailableMessage: "Mensaje cuando la IA no está disponible",
          unavailableMessageHelp: "Se envía cuando Agents no está disponible o no tiene créditos. En modo operativo también se usa para una respuesta no válida. Déjelo vacío para usar el mensaje predeterminado. Los mensajes proactivos no envían este aviso al contacto.",
          failureTitle: "Contingencia por fallo de atención",
          failureHelp: "Talk no repite automáticamente una solicitud para corregir un fallo. Envía este aviso una vez y pausa la IA en el ticket. Para continuar, el equipo debe asumir la atención y luego asignarla nuevamente al agente tras resolver la causa. La pausa impide mensajes proactivos y cierre por inactividad.",
          failureTransfer: "Transferir a una cola en caso de fallo",
          failureQueue: "Cola de contingencia",
          failureQueueHelp: "Elija una cola que permita atención manual y no asigne tickets automáticamente a la IA. Sin transferencia habilitada, la atención queda pausada con una actividad para revisión del equipo. Esto también cubre falta de créditos y respuestas no válidas.",
          failureQueueSelect: "Seleccione una cola de atención humana",
          failureQueueUnavailable: "Cola guardada no disponible para contingencia",
          failureUnsupported: "La configuración de contingencia utiliza una versión no compatible. Conserve los datos y solicite revisión.",
          proactiveClosureKeywords: "Frases que cierran en silencio",
          proactiveClosureKeywordsHelp: "Campo mantenido por compatibilidad. Prefiera usar el prompt de cierre en silencio.",
          proactiveClosurePrompt: "Prompt de cierre en silencio",
          proactiveClosurePromptHelp: "Instruccion enviada a Flowch Agents para decidir si la ultima respuesta del contacto permite cerrar la atencion sin enviar otro mensaje. Pida solo JSON con shouldClose, confidence y reason.",
          proactiveCloseSilently: "Cerrar en silencio cuando el contacto confirma que se resolvio",
          allowDirectTicketClosure: "Permitir que el agente cierre atenciones directamente",
          allowDirectTicketClosureHelp: "Desactivado: el agente continúa atendiendo y solo el flujo configurado de mensajes activos o inactividad puede cerrar el ticket.",
          operationalSkills: {
            title: "Herramientas operativas",
            help: "Active solo las acciones que este agente realmente necesita. Menos herramientas reducen decisiones innecesarias y respuestas técnicas. La transferencia es la configuración recomendada para agentes nuevos.",
            items: {
              talk_handoff: {
                label: "Transferir atenciones",
                help: "Permite transferir a una cola, persona u otro agente de IA conservando la atención."
              },
              talk_query_context: {
                label: "Consultar contexto operativo",
                help: "Ofrece listas de colas y agentes. Active solo cuando el agente necesite buscar destinos antes de transferir."
              },
              talk_add_internal_note: {
                label: "Registrar notas internas",
                help: "Permite agregar registros internos auditables a la atención."
              },
              talk_update_contact: {
                label: "Actualizar datos del contacto",
                help: "Permite cambiar nombre, correo o número del contacto durante la atención."
              }
            }
          },
          loopHandoffQueue: "Cola para transferencia si detecta bucle de IA",
          smartHandoff: "Transferencias inteligentes",
          smartHandoffHelp: "Permite que el agente entienda solicitudes naturales, consulte personas y colas disponibles y transfiera solo después de la validación de Flowch Talk. Viene activado por defecto.",
          loopHandoffQueueNone: "Usar la cola de transferencia de la cola actual",
          dissatisfactionEscalation: "Escalar contactos insatisfechos",
          dissatisfactionEscalationQueue: "Cola responsable de la recuperación",
          dissatisfactionEscalationQueueNone: "Selecciona la cola responsable",
          dissatisfactionEscalationHelp: "El agente hace un intento de recuperación. Si la insatisfacción continúa o se solicita un gerente o responsable, transfiere a esta cola sin repetir preguntas.",
          signMessages: "Enviar firma en los mensajes del agente",
          capabilitiesTitle: "Capacidades de atencion",
          capabilitiesHelp: "Use capacidades para orientar subagentes especialistas sin crear mas usuarios en Talk.",
          addCapability: "Agregar capacidad",
          removeCapability: "Eliminar capacidad",
          capabilityName: "Nombre de la capacidad",
          capabilityType: "Tipo de la capacidad",
          capabilityDescription: "Descripción resumida",
          capabilityInstructions: "Instrucciones de la capacidad",
          capabilityEnabled: "Activa",
          wizard: {
            loading: "Cargando modelos de agente...",
            title: "Creación guiada del agente",
            help: "Elige el sector, habilita capacidades e informa solo los datos necesarios. Talk crea las instrucciones técnicas.",
            advancedMode: "Configuración técnica",
            guidedMode: "Volver a la creación guiada",
            modeDraftPreserved: "La configuración del otro modo fue preservada y puede restaurarse.",
            modeSwitchToGuidedConfirm: "La creación guiada reemplazará la configuración técnica cuando guardes. ¿Deseas continuar?",
            steps: { objective: "Objetivo", knowledge: "Conocimiento", capabilities: "Capacidades", behavior: "Comportamiento", review: "Revisión" },
            objectiveTitle: "Da una identidad al agente y elige su sector",
            objectiveHelp: "Talk usará estas opciones para preparar una base segura y adecuada al tipo de atención.",
            agentName: "Nombre del agente",
            agentNameHelp: "Usa un nombre corto y fácil de reconocer, como Nair o Asistente de la Clínica.",
            segmentTitle: "¿Cuál es el sector de este agente?",
            segmentHelp: "El modelo define una base segura que se puede personalizar en los siguientes pasos.",
            templates: {
              medicalClinic: "Clínicas y salud",
              medicalClinicDescription: "Atención administrativa, dudas, profesionales y consultas.",
              technologyCompany: "Tecnología y SaaS",
              technologyCompanyDescription: "Producto, oportunidades, demostraciones y triaje de soporte.",
              otherBusiness: "Otro sector",
              otherBusinessDescription: "Modelo flexible para servicios, comercio y otros negocios.",
            },
            capabilitiesTitle: "¿Qué podrá hacer el agente?",
            capabilitiesHelp: "Activa solo lo que la empresa pueda respaldar con información e integraciones actuales.",
            advancedBadge: "Avanzada",
            recommendedBadge: "Recomendada",
            integrationBadge: "Puede requerir integración",
            capabilities: {
              faq: "Preguntas frecuentes",
              faqDescription: "Responde preguntas con la información registrada.",
              scheduling: "Agenda",
              schedulingDescription: "Orienta o agenda mediante enlaces e integraciones configurados.",
              appointmentManagement: "Confirmación y cambios de consultas",
              appointmentManagementDescription: "Confirma, cambia o cancela mediante el flujo autorizado.",
              professionalsSpecialties: "Profesionales y especialidades",
              professionalsSpecialtiesDescription: "Informa profesionales, especialidades, sedes y servicios.",
              coveragePrices: "Convenios y precios",
              coveragePricesDescription: "Informa cobertura, atención particular y precios registrados.",
              advancedOperations: "Operaciones avanzadas",
              advancedOperationsDescription: "Ejecuta acciones autorizadas en sistemas conectados.",
              technologyFaqDescription: "Responde preguntas del producto con documentación aprobada.",
              leadQualification: "Calificación de oportunidades",
              leadQualificationDescription: "Comprende necesidad, contexto, plazo y contacto.",
              demoScheduling: "Agenda de demostraciones",
              demoSchedulingDescription: "Agenda demostraciones mediante el flujo configurado.",
              supportTriage: "Triaje de soporte",
              supportTriageDescription: "Recopila contexto y deriva a la cola adecuada.",
              advancedIntegrations: "Integraciones avanzadas",
              advancedIntegrationsDescription: "Ejecuta operaciones configuradas con confirmación segura.",
              customerIntake: "Comprensión de la solicitud",
              customerIntakeDescription: "Hace preguntas breves para derivar correctamente.",
              generalSchedulingDescription: "Agenda servicios mediante el enlace o integración configurada.",
            },
            businessTitle: "Enseña lo esencial sobre el negocio",
            businessHelp: "Esta información será la fuente aprobada del agente. No incluyas contraseñas, tokens ni secretos.",
            moreKnowledgeTitle: "Agregar información útil",
            moreKnowledgeHelp: "Horarios, dirección, enlace de agenda y reglas específicas son opcionales.",
            fields: {
              organizationName: "Nombre de la empresa o sede",
              businessHours: "Horario de atención",
              summary: "¿Cómo explicarías el negocio a un nuevo agente?",
              summaryHelp: "Explica público, objetivo y límites de la atención.",
              services: "Servicios, especialidades, productos o información disponible",
              address: "Direcciones y sedes",
              schedulingUrl: "Enlace autorizado para agendar",
              schedulingUrlHelp: "Si está vacío, el agente no confirmará reservas automáticamente.",
              schedulingUrlRequiredHelp: "Obligatorio para capacidades de agenda. Usa un enlace completo que comience con http:// o https://.",
              advancedOperations: "¿Qué operaciones avanzadas están autorizadas?",
              advancedOperationsRequiredHelp: "Describe exactamente qué se puede ejecutar y qué confirmaciones son obligatorias.",
              noHandoffQueue: "Usar la cola de transferencia actual",
              additionalRules: "Reglas adicionales",
              additionalRulesHelp: "Informa políticas reales. Las reglas obligatorias de seguridad siguen activas.",
            },
            behaviorTitle: "Define cómo debe actuar el agente",
            behaviorHelp: "Los nombres técnicos de modelo, temperatura y tokens son administrados por Talk.",
            optionalBehaviorTitle: "Ajustes opcionales de respuesta y autonomía",
            optionalBehaviorHelp: "Los valores recomendados ya están seleccionados. Cámbialos solo si tu operación lo necesita.",
            routingTitle: "¿Dónde atenderá el agente?",
            routingHelp: "Elige al menos una cola y la conexión que recibirá las conversaciones. Esto evita publicar un agente sin punto de entrada.",
            queuesLabel: "Colas atendidas por el agente",
            selectConnection: "Selecciona una conexión",
            routingRequired: "Resuelve los elementos destacados: capacidad, cola, conexión y cualquier enlace o regla de operación obligatoria.",
            behavior: {
              intelligenceProfile: {
                title: "Inteligencia", help: "Equilibra velocidad, coste y profundidad.",
                essential: "Esencial — rápida y económica", balanced: "Equilibrada — recomendada", advanced: "Profunda — casos complejos",
              },
              tone: {
                title: "Tono", help: "Cómo debe conversar el agente con los clientes.",
                welcoming: "Acogedor", professional: "Profesional", casual: "Cercano y natural", technical: "Técnico",
              },
              responseLength: {
                title: "Extensión de respuestas", help: "La profundidad no cambia; solo la presentación.",
                short: "Breves", balanced: "Equilibradas", detailed: "Detalladas",
              },
              autonomyLevel: {
                title: "Autonomía", help: "Controla si el agente solo orienta o también ejecuta acciones.",
                answer_only: "Solo responde", suggest_actions: "Sugiere acciones", confirm_actions: "Ejecuta tras confirmación", automatic: "Automática para acciones autorizadas",
              },
            },
            reviewTitle: "Protecciones incluidas en esta configuración",
            review: {
              agent: "Agente",
              segment: "Sector",
              capabilities: "Capacidades activas",
              queues: "Colas",
              connection: "Conexión predeterminada",
              behavior: "Comportamiento",
              usage: "Uso estimado",
              safePrompt: "Las reglas obligatorias del sector se agregan automáticamente.",
              humanHandoff: "Las solicitudes fuera del alcance ofrecen atención humana.",
              onlyEnabled: "Solo las capacidades habilitadas entran en las instrucciones.",
              versionedTemplate: "El modelo y su versión quedan registrados para futuras actualizaciones.",
            },
            readyToPublish: "Configuración revisada",
            finalReviewTitle: "¿Todo listo para publicar?",
            finalReviewHelp: "Talk comprobó todos los elementos necesarios. Vuelve a una etapa si quieres ajustar algo.",
            readiness: {
              name: "Nombre del agente", template: "Plantilla del sector", organization: "Información de la organización",
              capabilities: "Capacidades habilitadas", connection: "Conexión predeterminada", queues: "Cola de atención",
              scheduling: "Enlace de agenda", operations: "Reglas de operaciones avanzadas", autonomy: "Límites de autonomía",
              ready: "Configurado", missing: "Necesita ajustes",
            },
            usage: {
              title: "Estimación de uso",
              summary: "Hasta {{tokens}} tokens por respuesta · consumo relativo {{cost}}",
              help: "Es una referencia de límite y consumo. El coste real depende del proveedor, el contrato y el volumen de contexto.",
              cost: { low: "bajo", medium: "medio", high: "alto" },
            },
            simulator: {
              title: "Simular antes de publicar",
              help: "Prueba una pregunta en una conversación aislada. El simulador no crea un ticket, no usa un contacto real y no envía nada a WhatsApp.",
              message: "Mensaje de prueba",
              placeholder: "Ej.: ¿Aceptan mi seguro médico?",
              run: "Simular respuesta",
              running: "Simulando...",
              saveFirst: "Guarda como borrador y vuelve a abrir el agente para habilitar la simulación.",
              operationsNote: "La vista previa valida conocimiento, tono y límites. Prueba transferencias y otras operaciones después en un canal controlado.",
            },
            testTitle: "Validación recomendada después de publicar",
            testHelp: "Después de crear, envía estos mensajes por un canal de prueba antes de dirigir clientes reales:",
            test: {
              knownQuestion: "Una pregunta común incluida en la información registrada.",
              unknownQuestion: "Una pregunta fuera del alcance para confirmar que el agente no inventa respuestas.",
              humanRequest: "Una solicitud de atención humana para validar la transferencia.",
            },
            back: "Volver",
            next: "Continuar",
            finishReview: "Concluir revisión",
            saveDraft: "Guardar borrador",
            draftSaved: "Borrador del agente guardado.",
            publish: "Publicar agente",
          },
        },
        accessSchedule: {
          title: "Horario de acceso",
          help: "Controle cuándo este usuario puede acceder o cuándo este agente de IA puede responder. Los mensajes se siguen recibiendo normalmente y quedan esperando el próximo horario permitido.",
          enabled: "Activar control de horario",
          profile: "Perfil de horario",
          customProfile: "Configuración personalizada",
          saveAsProfileName: "Guardar esta configuración como perfil",
          saveAsProfileNameHelp: "Opcional. Use esto para reutilizar el mismo horario en otros usuarios.",
          timezone: "Zona horaria",
          daysOfWeek: "Días permitidos",
          startTime: "Inicio",
          endTime: "Fin",
          warnBeforeMinutes: "Avisar cuántos minutos antes del fin",
          forceLogoutHumans: "Forzar cierre de sesión de usuarios humanos fuera del horario",
          pauseAiOutsideHours: "Pausar agentes de IA fuera del horario",
          blockHumanActionsOutsideHours: "Bloquear acciones humanas fuera del horario",
          temporaryOverrideTitle: "Liberación temporal",
          temporaryOverrideHelp: "Use esto cuando un administrador necesite liberar más tiempo sin cambiar el horario predeterminado.",
          temporaryOverrideUntil: "Permitir acceso hasta",
          temporaryOverrideReason: "Motivo de la liberación",
          warningToast: "En {{minutes}} min. se cerrará su sesión porque está cerca del fin del expediente.",
          forceLogoutToast: "Su horario de acceso terminó. La sesión fue cerrada automáticamente.",
          weekdays: {
            sun: "Domingo",
            mon: "Lunes",
            tue: "Martes",
            wed: "Miércoles",
            thu: "Jueves",
            fri: "Viernes",
            sat: "Sábado"
          }
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          saving: "Guardando...",
          cancel: "Cancelar",
        },
        validation: {
          required: "Campo obligatorio",
          tooShort: "Introduce al menos 2 caracteres",
          tooLong: "El valor introducido es demasiado largo",
          passwordMinimum: "La contraseña debe tener al menos 5 caracteres",
          invalidEmail: "Introduce un correo válido",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona una atención para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nueva Conversacion",
        },
      },
      ticketsUserSelect: {
        placeholder: "Atendentes",
        all: "Todos",
        unassigned: "Sin atendente",
        only: "Solo",
        onlyTooltip: "Filtrar solo este elemento",
        allTooltip: "Mostrar todos",
        selectAllTooltip: "Seleccionar todos",
        clearAllTooltip: "Deseleccionar todos",
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
        all: "Todas",
        noQueue: "Sin fila",
        only: "Solo",
        onlyTooltip: "Filtrar solo este elemento",
        allTooltip: "Mostrar todas",
        selectAllTooltip: "Seleccionar todas",
        clearAllTooltip: "Deseleccionar todas",
      },
      tickets: {
        toasts: {
          deleted: "La atención en la que estabas ha sido borrada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar atenciones y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Atención",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        noQueueUsers: "No se encontraron agentes en esta cola",
        queueUsersLabel: "Agentes disponibles en la cola de destino",
        loadingQueueUsers: "Cargando agentes de la cola...",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron atenciones con este estado o término de búsqueda",
        closedTag: "Resuelto",
        groupTag: "Grupo",
        buttons: {
          accept: "Acceptar",
        },
      },
      groupParticipantsModal: {
        title: "Participantes del grupo",
        ticketTitle: "Participantes de la atención",
        openButton: "Gestionar participantes",
        description:
          "Elija qué usuarios internos pueden acompañar este grupo en Flowch Talk. Esto no cambia los miembros reales del grupo de WhatsApp; solo controla quién acompaña e interactúa aquí.",
        ticketDescription:
          "Elija qué usuarios internos pueden acompañar e interactuar en esta atención sin cambiar el atendente responsable.",
        userLabel: "Usuario",
        userPlaceholder: "Seleccione un usuario",
        empty: "Aún no se agregó ningún participante interno.",
        roles: {
          admin: "Admin",
          member: "Participante",
          viewer: "Lector",
        },
        buttons: {
          add: "Agregar",
          remove: "Eliminar participante",
          close: "Cerrar",
        },
        toasts: {
          added: "Participante agregado.",
          removed: "Participante eliminado.",
        },
      },
      newTicketModal: {
        title: "Crear Atención",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        queueLabel: "Cola",
        queuePlaceholder: "Seleccione una cola",
        userLabel: "Agente",
        userPlaceholder: "Seleccione un agente",
        loadingUsers: "Cargando agentes...",
        connectionLabel: "Conexion",
        connectionPlaceholder: "Selecciona una conexion",
        loadingConnections: "Cargando conexiones...",
        noConnections: "No hay ninguna conexion activa disponible",
        noQueueUsers: "No hay colas disponibles para su usuario",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Atenciones",
          indicators: "Indicadores",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Colas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        connectionWarning: "Hay una conexión QR Code que necesita atención.",
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          id: "ID",
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          aiAgents: "Agentes de IA",
          actions: "Comportamiento",
        },
        aiAgents: {
          enabled: "Permitido",
          disabled: "Bloqueado",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Las atenciones en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          type: "Tipo",
          whatsapp: "Conexión estándar",
          status: "Estado",
          actions: "Acciones",
        },
        userTypes: {
          human: "Humano",
          ai_agent: "Agente de IA",
        },
        status: {
          online: "En línea",
          offline: "Offline",
        },
        aiStatus: {
          ready: "Listo",
          draft: "Borrador",
          pending_config: "Configurar",
          pending_sync: "Sincronizando",
          error: "Error",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Las atenciones abiertas de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        apiDocs: {
          copied: "Copiado al portapapeles!",
          intro: "Defina reglas globales de atencion y consulte los datos usados por integraciones externas. Use el token con cuidado y prefiera connectionId en nuevas integraciones.",
          generalTitle: "Configuraciones generales",
          generalDescription: "Controles de comportamiento usados en toda la operacion.",
          apiTitle: "Integraciones via API",
          apiDescription: "Token, endpoints y ejemplos para que sistemas externos envien mensajes y administren atenciones.",
          tokenTitle: "Token de API",
          tokenHelp: "Use este token en el header de autorizacion. Evite compartirlo en capturas, URLs o mensajes publicos.",
          copyToken: "Copiar Token",
          quickDocTitle: "Documentacion rapida de la API",
          overview: "Vision general",
          overviewToken: "Use el token anterior en el header Authorization: Bearer SU_TOKEN.",
          overviewNumber: "El número acepta espacios, paréntesis, guiones y prefijo +. Si un teléfono brasileño incluye solo el código de área, el código de país 55 se agrega automáticamente. Ejemplo normalizado: 5519978175005.",
          overviewConnection: "Informe connectionId en nuevas integraciones para elegir la conexion correcta.",
          overviewTransfer: "Si desea un endpoint mas explicito para transferencia, use /transfer.",
          overviewResolve: "Para cerrar una atencion abierta usando el numero del contacto, use /resolve.",
          requiredHeaders: "Headers obligatorios",
          sendMessage: "1. Enviar mensaje",
          sendDescription: "Use este endpoint para enviar un mensaje y, en la misma solicitud, dirigir la conversación a una cola y un usuario específicos.",
          transferQueue: "2. Cambiar de cola",
          transferDescription: "Use este endpoint para transferir la conversación a una cola y, opcionalmente, asignarla a un usuario de esa cola. También puede enviar un mensaje con la transferencia.",
          sendTemplate: "3. Enviar plantilla de WhatsApp Oficial",
          templateDescription: "Use este endpoint para iniciar o reanudar una conversación de WhatsApp Oficial con una plantilla aprobada por Meta. También puede definir la cola y el usuario responsable.",
          templateConnectionIdHint: "Para WhatsApp Oficial, use el ID que aparece en la pantalla de Conexiones. La cola informada debe pertenecer al mismo cliente que la conexion.",
          templateConnectionRequired: "obligatorio; acepta el ID que aparece en la pantalla de Conexiones para una conexion de WhatsApp Oficial",
          templateNameRequired: "nombre exacto de la plantilla aprobada por Meta",
          templateLanguage: "codigo de idioma aprobado, por ejemplo pt_BR",
          templateParameters: "objeto con valores por nombre para plantillas nombradas, como nome y data; las plantillas posicionales antiguas siguen aceptando una lista en el orden de las variables",
          resolveConversation: "4. Finalizar atencion",
          resolveDescription: "Cierra la atencion abierta mas recientemente actualizada del contacto. Sigue las mismas reglas que el cierre manual en Flowch Talk.",
          resolveNumberRequired: "único campo obligatorio; acepta entrada formateada y agrega 55 automáticamente a teléfonos brasileños con código de área",
          resolveBehavior: "Al finalizar, el sistema envia el mensaje de cierre configurado en la cola, registra el historial, actualiza la interfaz en tiempo real y ejecuta las integraciones de fin de atencion. Tambien se envia la despedida heredada de la conexion cuando esta configurada.",
          resolveSuccess: "Respuesta exitosa:",
          resolveValidation: "Validacion recomendada: confirme el estado closed en la respuesta y verifique que la atencion salio de las listas En atencion/En espera. Si la cola tiene un mensaje final, confirme tambien que fue registrado en la conversacion.",
          resolveAlreadyClosed: "Si la atencion mas reciente de este numero ya esta cerrada, la API devuelve 409 con ERR_API_TICKET_ALREADY_CLOSED. Use esta respuesta para tratar la llamada como duplicada o ya procesada.",
          resolveMethod: "Este endpoint solo acepta POST. Las llamadas GET devuelven 405 con ERR_API_RESOLVE_METHOD_NOT_ALLOWED.",
          recommendedNew: "recomendado para nuevas integraciones",
          required: "obligatorio",
          requiredWithoutMedia: "obligatorio cuando no hay medios",
          optionalQueue: "opcional, pero recomendado cuando ya desea enrutar la atencion",
          optionalUser: "opcional; ID del usuario responsable de la conversación",
          userAssignmentValidation: "Cuando se informa userId, la API valida que el usuario pertenezca a la misma empresa, esté asociado a la cola resuelta y, si es un agente de IA, que la cola permita IA y el agente esté listo. Si se omite queueId, se utiliza la cola ya resuelta en la conversación o conexión.",
          aiContextHandoff: "Si la atención está asignada a una IA lista, Talk importa el contexto reciente al crear la conversación en Agents. Los envíos posteriores por API entran como contexto incremental en la siguiente interacción. En V2, los envíos confirmados inician los plazos configurados de seguimiento e inactividad; transferir sin mensaje no inicia un plazo. Fuera de la ventana de respuesta libre de WhatsApp Oficial, se omite el seguimiento y el cierre por inactividad no envía despedida. Verifique el mensaje, responsable y estado del ticket.",
          successResponse: "Ejemplo de respuesta exitosa:",
          optionalLegacy: "opcional, mantenido solo para integraciones legadas",
          optional: "opcional",
          javascriptExample: "Ejemplo en JavaScript",
          expectedResponses: "Respuestas esperadas",
          response200: "operacion completada correctamente",
          response400: "número, queueId, userId, connectionId o body inválidos; también se devuelve cuando el usuario no pertenece a la cola",
          response409: "la operación requiere otra acción o el agente de IA seleccionado aún no está listo",
          response401: "token ausente o invalido",
          response404: "cola, conexion o atencion abierta no encontrada",
          response503: "conexion sin sesion activa",
        },
        aiAgents: {
          title: "Flowch Agents",
          description: "Clave y endpoint usados por los agentes de IA de este cliente.",
          help: "Configure la clave del tenant en Flowch Agents. Queda cifrada en el backend, aparece enmascarada despues de guardar y nunca se envia al frontend en texto abierto.",
          apiUrl: "URL de la API",
          apiUrlHelp: "Use el valor oficial por defecto, salvo cuando el cliente use un ambiente dedicado.",
          apiKey: "Clave de la API",
          apiKeyHelp: "Pegue una nueva clave para reemplazar la actual. Si aparece enmascarada, ya esta configurada.",
          companyWebsite: "Sitio web del cliente",
          companyWebsiteHelp: "Opcional. Si Flowch Agents no está disponible, esta dirección se mostrará al contacto como alternativa para agendar citas. Si se deja vacío, el mensaje mencionará solamente la atención telefónica.",
          companyWebsitePlaceholder: "https://www.ejemplo.com",
          save: "Guardar Flowch Agents",
          internalSkillsTitle: "Skills internas de Talk",
          internalSkillsDescription: "Estas rutas son privadas y llamadas por Flowch Agents para ejecutar acciones controladas en la atencion. El secreto de firma lo crea el backend y no se muestra en pantalla.",
          skillQueryContext: "talk_query_context: consulta contexto seguro de la atencion actual.",
          skillRequestHuman: "talk_request_human: solicita atencion humana y puede mover a la cola de handoff.",
          skillTransferQueue: "talk_transfer_queue: transfiere a otra cola que permita agentes de IA.",
          skillCloseAttendance: "talk_close_attendance: finaliza la atencion usando las reglas de Talk.",
          skillAddNote: "talk_add_internal_note: registra una nota interna auditable.",
          skillUpdateContact: "talk_update_contact: actualiza nombre, email o numero del contacto.",
          internalSkillsValidation: "Toda llamada valida firma, empresa, ticket, usuario de IA responsable y permiso de IA en la cola antes de ejecutar cualquier accion.",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          allowSignMessageChoice: {
            name: "Permitir que el usuario elija la firma",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        previousAttendance: {
          load: "Cargar atencion anterior",
          loading: "Cargando atencion anterior...",
          none: "No hay atencion anterior para este contacto.",
          title: "Atencion anterior",
          whatsappHistoryLoad: "Buscar historial anterior en WhatsApp",
          whatsappHistoryLoading: "Buscando historial en WhatsApp...",
          whatsappHistoryImported: "{{count}} mensajes sincronizados.",
          whatsappHistoryEmpty: "No se encontraron nuevos mensajes antiguos en este bloque.",
        },
        internalEvents: {
          show: "Eventos internos",
          hide: "Ocultar eventos internos",
          loading: "Cargando eventos internos...",
          empty: "No hay eventos internos para esta atencion.",
          systemAuthor: "Sistema",
          types: {
            message_received: "Mensaje recibido",
            message_sent: "Mensaje enviado",
            conversation_created: "Atencion creada",
            conversation_reopened: "Atencion reabierta",
            conversation_opened: "Atencion abierta",
            ai_operational_failure: "Atención de IA interrumpida por un fallo; se requiere revisión del equipo",
            ai_operational_action_blocked: "Acción de IA no ejecutada por las reglas de atención; la conversación sigue disponible.",
            ai_operational_pending: "La operación de IA requiere revisión del equipo. Revise la atención y asuma el siguiente paso antes de repetir una acción.",
            ai_operational_close_resolved: "Atención cerrada por resolución validada.",
            ai_operational_close_inactivity: "Atención cerrada por el plazo configurado de inactividad.",
            ai_operational_transfer: "Transferencia validada y registrada.",
            ai_operational_reply: "Respuesta de IA registrada; confirme el envío en la conversación.",
            ai_operational_clarify: "Aclaración registrada; revise la oferta y la respuesta del contacto.",
            ai_operational_no_reply: "La IA decidió no responder; esto no significa resolución.",
            ai_operational_clock_cancelled: "Espera automática del envío externo cancelada. El seguimiento comienza después de una atención efectiva de la IA.",
            ai_operational_continuation_cancelled: "Continuidad anterior cancelada tras un cambio de contexto.",
            conversation_closed: "Atencion cerrada",
            conversation_status_changed: "Estado cambiado",
            assignment_changed: "Atendente cambiado",
            queue_changed: "Cola cambiada",
            ai_proactive_message_sent: "Mensaje activo de IA",
            ai_proactive_attendance_closed: "Atencion cerrada por IA",
            ai_skill_human_requested: "IA solicito atencion humana",
            ai_skill_attendance_closed: "IA cerro la atencion",
            ai_skill_queue_transferred: "IA transfirio a cola",
            ai_skill_user_transferred: "IA transfirio a atendente",
            ai_skill_internal_note_added: "Nota interna de IA",
            internal_note_added: "Nota interna",
          },
        },
        mediaUnavailable: {
          default: "Medio no disponible.",
          image: "Imagen no disponible.",
          audio: "Audio no disponible.",
          video: "Video no disponible.",
          document: "Documento no disponible.",
          sticker: "Sticker no disponible.",
        },
        internalNote: {
          open: "Nota interna",
          title: "Agregar nota interna",
          mentionsLabel: "Mencionar usuarios",
          mentionsPlaceholder: "Seleccione usuarios para mencionar con @",
          noteLabel: "Nota interna",
          notePlaceholder: "Escriba una nota interna. Los usuarios mencionados con @ serán agregados como participantes de la atención.",
          cancel: "Cancelar",
          save: "Guardar nota",
          saving: "Guardando...",
          toasts: {
            saved: "Nota interna guardada.",
          },
        },
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            returnToPending: "Volver a En espera",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte esta atención para enviar un mensaje.",
        signMessage: "Firmar",
        internalNote: {
          toggle: "Mensaje interno",
          activeHint:
            "El modo de nota interna está activo. Este mensaje solo será visible para el equipo y no se enviará al contacto.",
          placeholder:
            "Escriba una nota interna. Use @Nombre para mencionar y agregar usuarios como participantes.",
          mentionAll: "Todos",
          mentionAllHint: "Notificar a todos los participantes y usuarios disponibles",
          mentionUserHint: "Usuario de Talk",
        },
        templateChooser: {
          title: "Elija una plantilla aprobada",
          description:
            "Este contacto está fuera de la ventana de 24 horas. Seleccione una plantilla para continuar.",
          metaRules:
            "Reglas de Meta (API Oficial): fuera de 24 horas solo se permiten plantillas aprobadas; evite repetir la misma plantilla para la misma atención y priorice contenido contextual para reducir bloqueos.",
          selectLabel: "Plantilla",
          parameterLabel: "Valor para {{variable}}",
          parametersRequired: "Complete todas las variables de la plantilla antes de enviar.",
          previewLabel: "Mensaje de plantilla",
          cancel: "Cancelar",
          send: "Enviar plantilla",
          sending: "Enviando...",
        },
      },
      messageInput: {
        audio: {
          errors: {
            permissionDenied: "Permite el acceso al micrófono en el navegador para grabar el audio.",
            deviceNotFound: "No se encontró ningún micrófono en este dispositivo.",
            deviceUnavailable: "El micrófono está ocupado o no disponible. Cierra otras aplicaciones que puedan estar usándolo e inténtalo de nuevo.",
            notSupported: "Este navegador no admite la grabación de audio. Actualiza el navegador o utiliza otro dispositivo.",
            emptyAudio: "No se capturó audio. Graba de nuevo y espera un momento antes de enviarlo.",
            recordingFailed: "No se pudo grabar el audio. Comprueba el micrófono e inténtalo de nuevo.",
          },
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        copyLink: "Copiar enlace de la actividad",
        copyLinkSuccess: "Enlace de la actividad copiado.",
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar atención #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con la atención se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        resend: "Reenviar",
        resending: "Reenviando...",
        resendSuccess: "Mensaje reenviado. Espere la confirmación de WhatsApp.",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_AI_OPERATIONAL_PROMPT_TOO_LONG: "Las instrucciones y el contrato operativo superan el límite de Agents. Reduzca el prompt editable conservando los datos importantes y vuelva a intentar.",
        ERR_AI_OPERATIONAL_POLICY_INVALID: "Revise la política: seleccione destinos válidos e indique plazos enteros mayores que cero para las opciones habilitadas.",
        ERR_AI_OPERATIONAL_POLICY_CONFLICT: "Otra persona cambió esta configuración. Vuelva a abrir el formulario, revise la versión actual y guarde de nuevo.",
        ERR_AI_OPERATIONAL_DESTINATION_INVALID: "Un destino seleccionado no está disponible en esta empresa o cola. Vuelva a abrir el formulario y revise la selección.",
        ERR_AI_OPERATIONAL_SKILL_DISABLED: "Esta herramienta no ejecuta operaciones en el nuevo modo. Transferencia y cierre requieren una decisión validada por Talk.",
        ERR_CONNECTION_OUTBOUND_QUEUE_INVALID: "Una de las colas autorizadas no pertenece a esta organización.",
        ERR_NO_CONNECTION_FOUND: "No se encontró la conexión correspondiente.",
        ERR_NETWORK_UNAVAILABLE:
          "La conexión con el servidor se interrumpió. Espere unos instantes e inténtelo nuevamente.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_OFFICIAL_SESSION_NOT_ALLOWED:
          "Esta acción de sesión está disponible solo para conexiones QR Code.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_CONTACT_INVALID_NUMBER:
          "Ingrese un teléfono válido con códigos de país y área. Para números de Brasil, +55 se agrega automáticamente.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_EMPTY_PROVIDER_RESPONSE:
          "WhatsApp Web no confirmó el envío del mensaje. Reinicie la conexión QR Code e inténtelo nuevamente.",
        ERR_WAPP_MESSAGE_NOT_ACKNOWLEDGED:
          "WhatsApp no confirmó este mensaje. La conexión QR Code se verificará automáticamente.",
        ERR_MESSAGE_NOT_FOUND: "Mensaje no encontrado.",
        ERR_MESSAGE_RESEND_NOT_SUPPORTED:
          "El reenvío está disponible solo para mensajes de texto en conexiones WhatsApp QR Code.",
        ERR_MESSAGE_RESEND_MEDIA_NOT_SUPPORTED:
          "El reenvío de medios aún no está disponible. Envíe el archivo nuevamente.",
        ERR_MESSAGE_RESEND_NOT_ALLOWED:
          "Este mensaje no puede reenviarse. Ya fue confirmado, borrado o reenviado.",
        ERR_HISTORY_SYNC_NOT_SUPPORTED:
          "La búsqueda de historial anterior está disponible solo para conexiones WhatsApp QR Code.",
        ERR_HISTORY_SYNC_NO_WHATSAPP:
          "No hay una conexión WhatsApp QR Code vinculada a esta atención.",
        ERR_HISTORY_SYNC_FETCH_FAILED:
          "No fue posible buscar el historial en WhatsApp Web. Reinicie la conexión QR Code e inténtelo nuevamente.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_OFFICIAL_PHONE_NOT_REGISTERED:
          "El número oficial configurado no está registrado en la WhatsApp Business Platform Cloud API. Verifique el registro del número en Meta.",
        ERR_OFFICIAL_MESSAGE_BLOCKED_BY_META:
          "Meta bloqueó este envío para mantener un ecosistema saludable de interacción. Intente nuevamente más tarde o revise el contenido/plantilla.",
        ERR_OFFICIAL_ACCESS_DENIED:
          "Meta negó este envío por el token o los permisos del número oficial. Reautorice la conexión o revise los permisos en Meta.",
        ERR_META_TRANSIENT_SEND_ERROR:
          "Meta devolvió un error temporal en el envío. Inténtelo nuevamente en unos instantes.",
        ERR_OFFICIAL_TEMPLATE_REQUIRED_OUTSIDE_24H:
          "Este mensaje no puede enviarse como texto libre porque la ventana de 24 horas está cerrada. Envíe una plantilla aprobada de Meta para reabrir la conversación.",
        ERR_API_CONNECTION_REQUIRED:
          "Informe la conexión que debe usarse en esta integración.",
        ERR_API_OFFICIAL_TEMPLATE_CONNECTION_REQUIRED:
          "El envío de plantillas exige una conexión de WhatsApp Oficial.",
        ERR_API_OPEN_TICKET_NOT_FOUND:
          "No se encontró ninguna atención abierta para este número.",
        ERR_API_RESOLVE_INVALID_NUMBER:
          "Informe un número válido para finalizar la atención.",
        ERR_API_TICKET_ALREADY_CLOSED:
          "Esta atencion ya estaba cerrada.",
        ERR_TICKET_ALREADY_CLOSED:
          "Esta atencion ya estaba cerrada.",
        ERR_API_RESOLVE_METHOD_NOT_ALLOWED:
          "Use POST para finalizar una atencion por la API.",
        ERR_OFFICIAL_TEMPLATE_NOT_ALLOWED_FOR_QUEUE:
          "La plantilla seleccionada no está permitida para la cola de esta atención.",
        ERR_OFFICIAL_TEMPLATE_ALREADY_SENT:
          "Esta misma plantilla ya fue enviada en esta atención. Elija otra plantilla aprobada.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_INVALID: "Elige un formato válido para las variables de la plantilla.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MIXED: "No mezcles variables por nombre y por posición en la misma plantilla.",
        ERR_META_TEMPLATE_PARAMETER_NAME_INVALID: "Usa nombres de variable en minúsculas, sin espacios ni acentos, como nombre_cliente.",
        ERR_META_TEMPLATE_POSITIONAL_SEQUENCE_INVALID: "Las variables posicionales deben empezar en la posición 1 y continuar sin saltos.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MISMATCH: "Las variables del texto no corresponden al formato seleccionado.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_WITHOUT_VARIABLES: "Quita el formato de variables o agrega al menos una variable al texto.",
        ERR_META_TEMPLATE_PARAMETER_EXAMPLE_REQUIRED: "Informa un ejemplo para cada variable de la plantilla.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay una atención abierta para este contacto.",
        ERR_OTHER_OPEN_TICKET_WITH_USER_QUEUE:
          "Ya existe la atención {{ticket}} abierta para este contacto con {{user}}, en la cola {{queue}}. Pida a ese usuario que le transfiera la atención.",
        ERR_OTHER_OPEN_TICKET_WITH_USER:
          "Ya existe la atención {{ticket}} abierta para este contacto con {{user}}. Pida a ese usuario que le transfiera la atención.",
        ERR_OTHER_OPEN_TICKET_WITH_QUEUE:
          "Ya existe la atención {{ticket}} abierta para este contacto en la cola {{queue}}, esperando atención.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_ACCESS_SCHEDULE_OUTSIDE_HOURS:
          "Su horario de acceso permitido terminó. Hable con un administrador si necesita una liberación temporal.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_TRANSFER_QUEUE_NOT_ALLOWED: "Solo puede transferir conversaciones dentro de las colas a las que pertenece.",
        ERR_TRANSFER_USER_NOT_IN_QUEUE: "El agente seleccionado no pertenece a la cola de destino.",
        ERR_AI_AGENT_NOT_READY: "El agente de IA seleccionado aún no está activo y listo para atender.",
        ERR_AI_AGENT_TEMPLATE_NOT_FOUND: "El modelo de agente seleccionado ya no existe. Elige otro modelo.",
        ERR_AI_AGENT_INTELLIGENCE_PROFILE: "Elige un nivel de inteligencia válido.",
        ERR_AI_AGENT_COMMUNICATION_PROFILE: "Elige opciones válidas de tono y extensión.",
        ERR_AI_AGENT_AUTONOMY_PROFILE: "Elige un nivel de autonomía válido.",
        ERR_AI_AGENT_CAPABILITY_NOT_FOUND: "Una capacidad seleccionada no pertenece a este modelo.",
        ERR_AI_AGENT_CAPABILITY_REQUIRED: "Habilita al menos una capacidad antes de publicar.",
        ERR_AI_AGENT_ORGANIZATION_REQUIRED: "Informa el nombre de la empresa o sede antes de publicar.",
        ERR_AI_AGENT_SIMULATION_MESSAGE_REQUIRED: "Escribe un mensaje de prueba de entre 2 y 1.500 caracteres.",
        ERR_AI_AGENT_SIMULATION_NOT_READY: "Guarda un borrador completo del agente antes de usar el simulador.",
        ERR_AI_AGENT_SIMULATION_EMPTY_RESPONSE: "El simulador no recibió una respuesta válida. Inténtalo de nuevo en unos instantes.",
        ERR_AI_DISSATISFACTION_QUEUE_REQUIRED: "Selecciona la cola responsable antes de activar el escalamiento de contactos insatisfechos.",
        ERR_AI_DISSATISFACTION_QUEUE_INVALID: "La cola responsable seleccionada no está disponible en esta empresa.",
        ERR_AI_INTERNAL_SKILLS_INVALID: "Seleccione solo herramientas operativas válidas para el agente.",
        ERR_REQUEST_BODY_TOO_LARGE: "Los datos enviados son demasiado extensos. Reduzca los campos de texto largos o envíe los archivos mediante el campo de adjuntos.",
        ERR_COMPANY_NOT_FOUND: "Organización no encontrada.",
        ERR_ORGANIZATION_LOGO_INVALID: "Use un logotipo PNG, JPG o WebP de hasta 2 MB.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ninguna atención con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_WHATSAPP_COEXISTENCE_DISABLED: "Las nuevas conexiones en coexistencia están desactivadas temporalmente en este entorno.",
        ERR_WHATSAPP_COEXISTENCE_CONFIG_REQUIRED: "La configuración de Embedded Signup para coexistencia aún no se completó en Meta.",
        ERR_WHATSAPP_COEXISTENCE_NOT_ACTIVE: "Meta no confirmó la coexistencia de este número. Verifica que siga activo en la aplicación WhatsApp Business y completa el flujo específico de coexistencia.",
        ERR_META_APPLICATION_NOT_FOUND: "La aplicación Meta no existe o no pertenece a tu empresa.",
        ERR_META_APPLICATION_INACTIVE: "La aplicación Meta seleccionada está inactiva.",
        ERR_META_APPLICATION_IN_USE: "Esta aplicación Meta está vinculada a una conexión y no puede eliminarse.",
        ERR_META_APPLICATION_REQUIRED_FIELDS: "Informe nombre, App ID y App Secret.",
        ERR_META_OAUTH_STATE_INVALID: "La autorización de Meta expiró o no pertenece a esta conexión. Inicia el proceso nuevamente.",
        ERR_META_OAUTH_STATE_SECRET_NOT_CONFIGURED: "La firma segura del inicio de sesión de Meta no está configurada en el servidor.",
        ERR_USER_REQUIRED: "Es obligatorio informar un agente responsable.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear la atención en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_QUEUE_MANUAL_ATTENDANCE_DISABLED:
          "Esta cola no permite atención manual. Transfiera la atención a otra cola antes de aceptarla.",
        ERR_QUEUE_AI_AGENTS_DISABLED:
          "Esta cola no permite agentes de IA. Active el permiso de la cola antes de asignar esta atención.",
        ERR_FLOWCH_AGENTS_API_KEY_NOT_CONFIGURED:
          "La clave de la API de Flowch Agents no está configurada en el backend.",
        ERR_FLOWCH_AGENTS_API_REQUEST_FAILED:
          "La API de Flowch Agents devolvió un error. Revise la configuración e intente nuevamente.",
        ERR_FLOWCH_AGENTS_TENANT_MISMATCH:
          "Esta clave pertenece a otro tenant de Flowch Agents y no contiene los agentes vinculados a esta empresa. Use una clave rotada del mismo tenant o desvincule los agentes antes de migrar.",
        ERR_FLOWCH_AGENTS_API_INVALID_RESPONSE:
          "La API de Flowch Agents devolvió una respuesta inválida.",
        ERR_AI_SKILL_SIGNATURE_REQUIRED:
          "La llamada de la skill interna necesita firma.",
        ERR_AI_SKILL_NAMESPACE_INVALID: "El namespace de herramientas debe comenzar con una letra minúscula y contener hasta 32 letras minúsculas, números o guiones bajos.",
        ERR_AI_SKILL_INVALID_SIGNATURE:
          "La firma de la skill interna es inválida.",
        ERR_AI_SKILL_NOT_SUPPORTED:
          "Esta skill interna no es compatible con Talk.",
        ERR_AI_FAILURE_POLICY_INVALID: "Revise la contingencia: seleccione una cola válida al habilitar la transferencia.",
        ERR_AI_FAILURE_OPERATIONAL_REQUIRED: "La transferencia por fallo requiere el modo operativo del agente.",
        ERR_AI_FAILURE_QUEUE_INVALID: "La cola de contingencia debe pertenecer a su empresa, permitir atención manual y no asignar automáticamente a la IA.",
        ERR_AI_INTERNAL_SKILL_DISABLED:
          "Esta herramienta operativa está desactivada para el agente responsable de la atención.",
        ERR_AI_SKILL_TICKET_REQUIRED:
          "Informe la atención antes de ejecutar la skill interna.",
        ERR_AI_SKILL_TICKET_NOT_ASSIGNED_TO_AI:
          "Esta atención no está asignada a un agente de IA.",
        ERR_AI_SKILL_NOTE_REQUIRED:
          "Informe la nota interna que debe registrarse.",
        ERR_INTERNAL_NOTE_REQUIRED:
          "Informe la nota interna que debe registrarse.",
        ERR_TICKET_PARTICIPANT_NOT_FOUND:
          "Participante de la atención no encontrado.",
        ERR_AI_SKILL_CONTACT_FIELDS_REQUIRED:
          "Informe al menos un campo del contacto para actualizar.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
